export default __webpack_public_path__ + "static/media/meetingSet.d4cc2c69.png";